import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import { miniCardHeight, miniCardWidth } from '../../../modules/utils/constants/constants';

export const StyledSearchMiniCardSlider = styled.div<{
  containerWidth: number;
}>`
  width: 100%;
  position: absolute;
  bottom: ${toRem(70)};
  z-index: 10;
  right: 0;
  left: 0;

  @media ${baseVariables.mediaQuery.md} {
    position: initial;
  }

  .carousel-container {
    width: ${props => (props?.containerWidth ? toRem(props?.containerWidth - 32) : '100vw')};
    overflow: hidden;
  }

  .search-mini-card {
    border-radius: ${toRem(14)};
  }

  .minicard__image {
    border-radius: ${toRem(14)} 0 0 ${toRem(14)};
  }

  .carousel-slider {
    width: 100%;
    min-height: ${toRem(miniCardHeight)};
    box-sizing: border-box;
  }

  .slide-container {
    width: ${toRem(miniCardWidth)};
    height: ${toRem(miniCardHeight)};
  }
`;
